import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';

import { AfterViewInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Storage } from '@ionic/storage';
import { Subscription } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { BasicService } from 'src/app/shared/services/basic.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UsersComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  set users(users) {
    this.dataSource = new MatTableDataSource(users);
    this.sortData({ active: this.sortActive || 'email', direction: this.sortDirection || 'asc' });
    this.resetPaginator();
  }

  @Input() routingTagExists;
  @Input() filtersFormGroup: FormGroup = new FormGroup({});
  @Input() dropdownItems: any;
  @Input() loading: boolean;
  @Output() userSelected: EventEmitter<any> = new EventEmitter();
  @Output() teamSelected: EventEmitter<any> = new EventEmitter();
  @Output() roleSelected: EventEmitter<any> = new EventEmitter();

  displayedColumns: string[] = ['email', 'name', 'is_active', 'is_admin', 'teams', 'roles'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  searchLabel: string;
  subscriptions: Subscription = new Subscription();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) matSort: MatSort;
  sortActive = 'email';
  sortDirection: 'asc' | 'desc' = 'asc';
  companyId = this.alcmeonContextService.getCompany().id;

  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private basicService: BasicService,
    private storage: Storage
  ) {
    this.searchLabel = `${this.basicService.translate('admin/users/email')} | ${basicService.translate('common/name')}`;
  }

  ngOnInit() {
    this.storage
      .get(`users-field-email-name-${this.companyId}`)
      .then(value => this.filtersFormGroup.get('searchInput').setValue(value));
    this.subscriptions.add(
      this.filtersFormGroup
        .get('searchInput')
        .valueChanges.subscribe(value => this.storage.set(`users-field-email-name-${this.companyId}`, value))
    );
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.matSort;
  }

  sortData($event) {
    const { active, direction } = $event;
    this.sortActive = active;
    this.sortDirection = direction;
    const listSorted = this.dataSource.data.sort((a: any, b: any) => {
      let result;
      switch (active) {
        case 'email':
        case 'name':
          result = (a[active] || '').localeCompare(b[active]);
          break;
        case 'is_active':
          result = (a.isActiveLabel || '').localeCompare(b.isActiveLabel);
          break;
        case 'is_admin':
          result = (a.isAdminLabel || '').localeCompare(b.isAdminLabel);
          break;
        case 'teams':
        case 'roles':
          result = a[active].length - b[active].length;
          break;
        default:
          break;
      }
      return result;
    });
    this.dataSource.data = direction === 'desc' ? listSorted.reverse() : listSorted;
  }

  private resetPaginator() {
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.paginator.length = this.dataSource.data.length;
      this.dataSource.paginator.firstPage();
    }
  }

  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
  }
}
